<template>
  <div class="app-layout-auth">
    <AppHeader />
    <main class="app-layout-auth__main">
      <slot />
    </main>
  </div>
</template>

<script setup>
// Layout pour les pages authentifiées (chat, profil, mon-compte...).
// Ces routes ont ssr: false dans nuxt.config.ts → rendu client uniquement.
// MSAL fonctionne normalement ici via le plugin msal.client.ts.
</script>

<style scoped>
.app-layout-auth {
  /* height strict (pas min-height) pour que les enfants puissent faire height:100% */
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--bg-base);
}

.app-layout-auth__main {
  flex: 1;
  /* height: 0 est le trick flex classique : permet aux enfants directs
     de faire height:100% dans un conteneur flex sans déborder */
  height: 0;
  padding-top: var(--header-height);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>
